import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c8de31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "address-form" }
const _hoisted_3 = { class: "el-dialog__body-footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { dayjs, ElMessage, FormInstance } from 'element-plus'
import { ref, reactive, watch, computed } from 'vue'
import PriceRate from '@/views/shopcart/components/PriceRate.vue'
import ShippingCompany from './ShippingCompany.vue'
import { syncOrder } from '@/apis/order'
import { confirmApiUnbind } from '@/util/useConfirm'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props



const searchDate = computed({
  get: () => [form.startTime, form.endTime],
  set: (newVal) => {
    [form.startTime, form.endTime] = newVal ?? []
  }
})

const dateValidator = (rule: any, value: any[], callback: any) => {
  const day = 7
  const fn = (start:string, end:string) => {
    return dayjs(start).add(day - 1, 'day').isBefore(dayjs(end))
  }
  if (!form.startTime || !form.endTime) {
    callback(t('必填'))
  } else if (fn(form.startTime, form.endTime)) {
    callback(t('所选日期区间长度不可超过X天').replace('X', day.toString()))
    setTimeout(() => {
      searchDate.value = []
    }, 100)
  } else {
    callback()
  }
}

const rules = {
  dateValidator: [
    {
      validator: dateValidator,
      trigger: 'blur'
    }
  ]
}

const form = reactive({
  startTime: '',
  endTime: ''
})

const init = () => {
  form.startTime = ''
  form.endTime = ''
}
watch(() => props.visible, (newValue) => {
  if (newValue) {
    init()
  }
})

const formRef: any = ref<FormInstance>()
const submitLoading = ref(false)
const submit = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.validate(async (valid: any) => {
    if (valid) {
      submitLoading.value = true
      const unbind = await confirmApiUnbind()
      submitLoading.value = false
      if (unbind) return
      submitLoading.value = true
      syncOrder(form).then((res: any) => {
        if (res.success) {
          setTimeout(() => { submitLoading.value = false }, 1000)
          emits('update:visible')
          emits('success')
        } else {
          submitLoading.value = false
          //
        }
      }).catch(() => { submitLoading.value = false })
    } else {
      return false
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('update:visible', false))),
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('选择订单时间')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            formRef.value = _value
          },
          inline: true,
          model: _unref(form),
          rules: rules,
          "label-width": "190px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('订单付款日期区间'),
              prop: "dateValidator",
              rules: [{ validator: dateValidator, trigger: 'blur' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(searchDate),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": _unref(t)('开始时间'),
                  "end-placeholder": _unref(t)('结束时间'),
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(ShippingCompany)
              ]),
              _: 1
            })),
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(PriceRate)
              ]),
              _: 1
            }))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: submitLoading.value,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (submit(formRef.value)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})